import React from 'react';
import { useTheme, createUseStyles } from 'react-jss';
import PropTypes from 'prop-types';
import Icon from '@mdi/react';
import { mdiFilePdfOutline } from '@mdi/js';
import classNames from 'classnames';

import Container from '@components/Container';

const useStyles = createUseStyles(({
  rem,
}) => ({
  record: {
    marginBottom: rem(10),
  },
}), {
  name: 'PDF'
})

const PDF = (props) => {
  const theme = useTheme();
  const classes = useStyles(theme);

  const {
    t,
    src,
    size, 
    className: classNameProp
  } = props;

  const handleDownloadPdf = () => {
    const aLink = global.document.createElement('a');

    const evt = global.document.createEvent('HTMLEvents');
    evt.initEvent('click', true, true);
    aLink.download = '货单PDF';
    aLink.href = src;

    aLink.dispatchEvent(new global.MouseEvent('click', {
      bubbles: true,
      cancelable: true,
      view: global.window,
    }));
  }

  return (
    <Container 
      flex
      alignItems='center'
      direction='column'
      justify='center'
      className={classNameProp}
      style={{ height: '95%' }}
      onClick={handleDownloadPdf}
    >
      <Icon
        size={size}
        path={mdiFilePdfOutline}
        className={classNames(classes.record)}
      />
      {t('receipt')}
    </Container>
  )
};

PDF.propTypes = {
  t: PropTypes.func.isRequired,
  src: PropTypes.string.isRequired,
  size: PropTypes.number.isRequired,
  className: PropTypes.string,
}

export default PDF;
